let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2SsCI")).then(() => parcelRequire('54J5r'));